import { render, staticRenderFns } from "./ApproveMailWebpart.vue?vue&type=template&id=f6e38cae"
import script from "./ApproveMailWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ApproveMailWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports